import { AodRuleReportTypeEnum, AodRun } from '@app/modules/audit/modules/aod/aod.types';
import AssessmentIcon from '@mui/icons-material/Assessment';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { ButtonGroup } from '@mui/material';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { AdaptiveButton } from '../../../../../../../../../components/base/AdaptiveButton';
import { ButtonLink } from '../../../../../../../../../components/base/ButtonLink';

interface Props {
  run: AodRun;
  buttonsVariant?: 'short' | 'long';
}

export function ViewReportResultsBtn({ run, buttonsVariant = 'short' }: Props) {
  const { $t } = useIntl();

  const to = useMemo(() => {
    const reportId = run.reportId!;
    return run.rule.reportType === AodRuleReportTypeEnum.AUDIT_GIP_STATUS
      ? `/audit/global-reports/gip-report?report=${reportId}`
      : `/audit/global-reports/gip-alternative-report?report=${reportId}`;
  }, [run.reportId, run.rule.reportType]);

  const viewResultsText = $t({
    id: 'audit.aod.actions.viewResults',
    defaultMessage: 'Ver resultados',
  });

  if (buttonsVariant === 'long') {
    return (
      <ButtonGroup size="small" color="primary" variant="outlined">
        <ButtonLink
          to={to}
          size="small"
          color="primary"
          variant="outlined"
          startIcon={<AssessmentIcon />}
        >
          {viewResultsText}
        </ButtonLink>
        <ButtonLink to={to} openInNewTab size="small" color="primary" variant="outlined">
          &nbsp;
          <OpenInNewIcon fontSize="small" />
          &nbsp;
        </ButtonLink>
      </ButtonGroup>
    );
  }

  return (
    <AdaptiveButton
      text={viewResultsText}
      icon={<AssessmentIcon />}
      display="short"
      to={to}
      size="small"
      color="primary"
    />
  );
}
